import { Link } from "react-router-dom";
import { useT } from "../../i18n";
import { PRIVACY_URL, TERMS_URL } from "../../constants/mintlabApps";
import LanguageSwitcher from "./LanguageSwitcher";
import "./site.css";

// Shared chrome (header + footer) for every public MintLab page.
export default function SiteShell({ children }) {
  const t = useT();
  const year = new Date().getFullYear();

  return (
    <div className="ml-site">
      <header className="ml-header">
        <div className="ml-header-inner">
          <Link to="/" className="ml-logo" aria-label="MintLab home">
            <img src="/mintlab-symbol.png" alt="" />
            <span>MintLab</span>
          </Link>
          <div className="ml-header-actions">
            <Link to="/support" className="ml-nav-link">{t("nav.support")}</Link>
            <LanguageSwitcher />
          </div>
        </div>
      </header>

      <main className="ml-main">{children}</main>

      <footer className="ml-footer">
        <div className="ml-footer-inner">
          <span>{t("footer.rights", { year })}</span>
          <nav className="ml-footer-links">
            <Link to="/support">{t("nav.support")}</Link>
            <a href={PRIVACY_URL}>{t("nav.privacy")}</a>
            <a href={TERMS_URL}>{t("nav.terms")}</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
